module.exports = __webpack_public_path__ + "static/media/suporte.7652a659.svg";